<div class="list-text-div">
    <span class="list-text" *ngIf="!plans || plans.length === 0">
        No Plans Selected
    </span>
    <span class="list-text" *ngFor="let carrier of objKeys(carrierCount); let isLast=last">
        {{carrier}}({{carrierCount[carrier]}}){{isLast ? '' : ', '}}
    </span>
</div>
